import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import Script from 'next/script';

import { URLS } from '../../../models/url/constants';
import analytics from '../../../analytics';
import config from '../../../config';
import GA4Analytics from '../../../analytics/ga4-analytics';

const GLOBAL_API_NAME = '__COOKIE_DISCLAIMER__';
const DISMISS_EVENT = 'cookie-disclaimer:dismiss';
const MOUNT_ID = 'cookie-disclaimer-mount';

const PRIVACY_POLICY_URL = URLS.SALES.PRIVACY;
const COOKIE_STATEMENT_URL = URLS.SALES.COOKIES_STATEMENT;
const cookieDomain = config.get('cookie:domain');
const scriptSrc = `${config.get('static:url')}/files/scripts/cookie-disclaimer/index.js`;

const useDisclaimerAnalytics = () => {
  const pathname = usePathname();
  const [isScriptReady, setIsScriptReady] = useState(false);

  useEffect(() => {
    if (!isScriptReady || !pathname) {
      return;
    }

    const disclaimer = (window as Window & { [GLOBAL_API_NAME]?: { element: HTMLElement | null } })[GLOBAL_API_NAME];
    if (disclaimer?.element) {
      GA4Analytics.submit({ name: 'view_cookies_consent_popup' });
    }
  }, [isScriptReady, pathname]);

  useEffect(() => {
    const handleDismiss = () => {
      analytics.publish('action', {
        action: 'clicked',
        component: 'element',
        label: 'dismiss_cookies_consent_popup',
      });
    };

    document.addEventListener(DISMISS_EVENT, handleDismiss);

    return () => document.removeEventListener(DISMISS_EVENT, handleDismiss);
  }, []);

  return () => setIsScriptReady(true);
};

// TODO: Temporary disclaimer banner until OneTrust is implemented. Please remove once OneTrust is integrated.
const CookieDisclaimerBanner = () => {
  const onReady = useDisclaimerAnalytics();

  return (
    <>
      <div id={MOUNT_ID} />
      <Script
        data-cookie-domain={cookieDomain}
        data-cookie-url={COOKIE_STATEMENT_URL}
        data-dismiss-event={DISMISS_EVENT}
        data-mount-selector={`#${MOUNT_ID}`}
        data-privacy-url={PRIVACY_POLICY_URL}
        onReady={onReady}
        src={scriptSrc}
        strategy="afterInteractive"
      />
    </>
  );
};

export default CookieDisclaimerBanner;
